import React from 'react';

import { getBgIconSite, getColorSite } from 'helper/colorSite';
import { IconCalendarWrapper, IconStyle } from '../Style/Style';
import { colors } from 'constants/colorsBase';

export const IconSetting = () => {
  return (
    <IconStyle viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="25" fill={getBgIconSite()} />
      <path
        d="M40.2217 22.1251L36.7312 21.9638C36.5745 21.9564 36.4232 21.9043 36.2953 21.8135C36.1673 21.7228 36.0681 21.5973 36.0093 21.4518L35.2899 19.7264C35.2305 19.5819 35.2134 19.4234 35.2406 19.2696C35.2678 19.1157 35.3382 18.9727 35.4435 18.8573L37.8 16.2742C37.9423 16.1176 38.0189 15.9121 38.0139 15.7005C38.0089 15.4889 37.9226 15.2874 37.7731 15.1376L34.8688 12.2346C34.7188 12.0848 34.5169 11.9986 34.3049 11.9938C34.093 11.9891 33.8874 12.0661 33.7309 12.209L31.144 14.5629C31.0284 14.6684 30.8851 14.7388 30.731 14.7658C30.5768 14.7927 30.4181 14.7752 30.2736 14.7152L28.5481 13.992C28.4025 13.9331 28.2769 13.8337 28.1861 13.7055C28.0954 13.5773 28.0433 13.4257 28.0361 13.2688L27.88 9.78464C27.8701 9.57352 27.7794 9.37429 27.6267 9.22821C27.4739 9.08214 27.2709 9.00043 27.0595 9H22.952C22.7405 9.00041 22.5373 9.08208 22.3843 9.22813C22.2314 9.37417 22.1404 9.57341 22.1302 9.78464L21.969 13.2752C21.9618 13.4321 21.9097 13.5837 21.819 13.7119C21.7282 13.8401 21.6026 13.9395 21.457 13.9984L19.7264 14.7165C19.5819 14.7766 19.4232 14.7942 19.269 14.7673C19.1148 14.7403 18.9715 14.6698 18.856 14.5642L16.2794 12.209C16.1228 12.0661 15.9172 11.9891 15.7053 11.9938C15.4934 11.9986 15.2914 12.0848 15.1414 12.2346L12.241 15.1376C12.0911 15.2872 12.0047 15.4888 11.9997 15.7005C11.9947 15.9122 12.0715 16.1177 12.2141 16.2742L14.568 18.856C14.6733 18.9714 14.7435 19.1146 14.7703 19.2685C14.797 19.4225 14.7792 19.5809 14.719 19.7251L14.0022 21.4557C13.9432 21.6012 13.8437 21.7268 13.7156 21.8175C13.5874 21.9082 13.4359 21.9604 13.279 21.9677L9.78976 22.129C9.5773 22.1376 9.3764 22.2281 9.22918 22.3815C9.08196 22.5349 8.99983 22.7394 9 22.952V27.048C9.0001 27.2596 9.08167 27.463 9.22777 27.616C9.37388 27.769 9.5733 27.8599 9.78464 27.8698L13.2739 28.031C13.4308 28.0384 13.5823 28.0905 13.7104 28.1812C13.8386 28.272 13.9381 28.3975 13.9971 28.543L14.7139 30.2736C14.7741 30.4178 14.7919 30.5762 14.7651 30.7302C14.7384 30.8842 14.6682 31.0273 14.5629 31.1427L12.2141 33.7258C12.0712 33.8823 11.9942 34.0879 11.999 34.2998C12.0037 34.5118 12.0899 34.7137 12.2397 34.8637L15.144 37.7654C15.2936 37.9153 15.4952 38.0017 15.7069 38.0067C15.9186 38.0117 16.1241 37.9349 16.2806 37.7923L18.856 35.4371C18.9716 35.3316 19.1149 35.2612 19.269 35.2342C19.4232 35.2073 19.5818 35.2248 19.7264 35.2848L21.457 36.0016C21.6025 36.0606 21.728 36.1601 21.8188 36.2883C21.9095 36.4164 21.9616 36.5679 21.969 36.7248L22.1302 40.2141C22.1401 40.4255 22.2309 40.6251 22.3839 40.7714C22.5369 40.9177 22.7403 40.9996 22.952 41H27.0582C27.2698 40.9999 27.4732 40.9183 27.6262 40.7722C27.7792 40.6261 27.8701 40.4267 27.88 40.2154L28.0413 36.7261C28.0486 36.5692 28.1007 36.4177 28.1914 36.2896C28.2822 36.1614 28.4077 36.0619 28.5533 36.0029L30.2838 35.2861C30.4284 35.2262 30.587 35.2088 30.7412 35.2358C30.8953 35.2627 31.0386 35.333 31.1542 35.4384L33.736 37.7936C33.8929 37.936 34.0985 38.0126 34.3103 38.0076C34.5221 38.0026 34.7239 37.9164 34.8739 37.7667L37.7757 34.8637C37.925 34.7135 38.0111 34.5118 38.0161 34.3001C38.0211 34.0884 37.9446 33.8828 37.8025 33.7258L35.4435 31.144C35.3379 31.0287 35.2673 30.8858 35.2401 30.7318C35.2129 30.5779 35.2302 30.4194 35.2899 30.2749L36.0093 28.5443C36.0681 28.3989 36.1673 28.2734 36.2953 28.1826C36.4232 28.0919 36.5745 28.0397 36.7312 28.0323L40.2217 27.871C40.4322 27.8596 40.6302 27.7678 40.775 27.6147C40.9198 27.4616 41.0003 27.2587 41 27.048V22.952C41.0016 22.7405 40.9216 22.5365 40.7766 22.3825C40.6317 22.2285 40.4329 22.1363 40.2217 22.1251V22.1251ZM25 30.2262C23.9666 30.2252 22.9566 29.9179 22.0978 29.343C21.2391 28.7681 20.57 27.9515 20.1752 26.9964C19.7805 26.0414 19.6777 24.9907 19.8799 23.9773C20.0822 22.9638 20.5803 22.0331 21.3114 21.3027C22.0425 20.5723 22.9738 20.0751 23.9874 19.8738C25.0011 19.6726 26.0516 19.7764 27.0063 20.1721C27.961 20.5678 28.7769 21.2377 29.3509 22.097C29.925 22.9563 30.2313 23.9666 30.2313 25C30.2312 25.6867 30.0957 26.3666 29.8327 27.001C29.5697 27.6353 29.1842 28.2116 28.6984 28.6969C28.2126 29.1823 27.6359 29.5671 27.0014 29.8295C26.3668 30.0919 25.6867 30.2267 25 30.2262Z"
        fill="white"
      />
    </IconStyle>
  );
};

export const IconDateInput = () => (
  <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 4H0V25H32V4Z" fill="white" />
    <path d="M31.25 4.75H0.75V24.25H31.25V4.75Z" stroke="#52B788" strokeWidth="1.5" />
    <path d="M32 0H0V3H32V0Z" fill="#52B788" />
    <path d="M31 1H1V2H31V1Z" stroke="#52B788" strokeWidth="2" />
    <path d="M11 0H8V2H11V0Z" fill="white" />
    <path d="M24 0H21V2H24V0Z" fill="white" />
    <path d="M10.25 0H8.75V1.5H10.25V0Z" fill="#52B788" />
    <path d="M23.25 0H21.75V1.5H23.25V0Z" fill="#52B788" />
    <path
      d="M13 19.1591C12.1439 19.1591 11.4148 18.9261 10.8125 18.4602C10.2102 17.9905 9.75 17.3106 9.43182 16.4205C9.11364 15.5265 8.95455 14.447 8.95455 13.1818C8.95455 11.9242 9.11364 10.8504 9.43182 9.96023C9.75379 9.06629 10.2159 8.38447 10.8182 7.91477C11.4242 7.44129 12.1515 7.20455 13 7.20455C13.8485 7.20455 14.5739 7.44129 15.1761 7.91477C15.7822 8.38447 16.2443 9.06629 16.5625 9.96023C16.8845 10.8504 17.0455 11.9242 17.0455 13.1818C17.0455 14.447 16.8864 15.5265 16.5682 16.4205C16.25 17.3106 15.7898 17.9905 15.1875 18.4602C14.5852 18.9261 13.8561 19.1591 13 19.1591ZM13 17.9091C13.8485 17.9091 14.5076 17.5 14.9773 16.6818C15.447 15.8636 15.6818 14.697 15.6818 13.1818C15.6818 12.1742 15.5739 11.3163 15.358 10.608C15.1458 9.89962 14.839 9.35985 14.4375 8.98864C14.0398 8.61742 13.5606 8.43182 13 8.43182C12.1591 8.43182 11.5019 8.84659 11.0284 9.67614C10.5549 10.5019 10.3182 11.6705 10.3182 13.1818C10.3182 14.1894 10.4242 15.0455 10.6364 15.75C10.8485 16.4545 11.1534 16.9905 11.5511 17.358C11.9527 17.7254 12.4356 17.9091 13 17.9091ZM23.2955 7.36364V19H21.8864V8.84091H21.8182L18.9773 10.7273V9.29545L21.8864 7.36364H23.2955Z"
      fill="#52B788"
    />
  </svg>
);

export const CheckIcon = ({ fill, height, width }: any) => {
  return (
    <IconStyle height={height} width={width} viewBox="0 0 44 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="7.12669"
        height="39.5928"
        rx="3.56335"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 43.124 5.34818)"
        fill={fill}
      />
      <rect
        x="0.982422"
        y="19.2608"
        width="7.12669"
        height="19.7964"
        rx="3.56335"
        transform="rotate(-45 0.982422 19.2608)"
        fill={fill}
      />
    </IconStyle>
  );
};

export const BlockIcon = ({ fill, height, width }: any) => {
  return (
    <IconStyle height={height} width={width} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="42.4254" y1="13.7035" x2="12.8293" y2="45.492" stroke={fill} strokeWidth="5" />
      <line x1="43.2322" y1="44.4802" x2="12.5204" y2="13.7683" stroke={fill} strokeWidth="5" />
    </IconStyle>
  );
};

export const UploadBanner = ({ background, height, width }: any) => {
  return (
    <IconStyle height={height} width={width} viewBox="0 0 99 98" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M95.8063 49C95.8063 74.6739 74.9263 95.5 49.1531 95.5C23.38 95.5 2.5 74.6739 2.5 49C2.5 23.3261 23.38 2.5 49.1531 2.5C74.9263 2.5 95.8063 23.3261 95.8063 49Z"
        fill={background || colors.whiteSmoke}
        stroke={getBgIconSite()}
        strokeWidth="5"
      />
      <path
        d="M45.3249 22.0133C47.323 19.6348 50.9835 19.6348 52.9816 22.0133L74.4751 47.5979C77.2079 50.8508 74.8953 55.8141 70.6468 55.8141H27.6597C23.4112 55.8141 21.0986 50.8508 23.8313 47.5979L45.3249 22.0133Z"
        fill={getBgIconSite()}
      />
      <path
        d="M37.0562 52.9813H61.5562V63.6C61.5562 66.3614 59.3176 68.6 56.5562 68.6H42.0562C39.2947 68.6 37.0562 66.3614 37.0562 63.6V52.9813Z"
        fill={getBgIconSite()}
      />
      <path
        d="M37.0562 75.7969C37.0562 74.3592 38.2216 73.1937 39.6593 73.1937H58.953C60.3907 73.1937 61.5562 74.3592 61.5562 75.7969C61.5562 77.2345 60.3907 78.4 58.953 78.4H39.6593C38.2216 78.4 37.0562 77.2345 37.0562 75.7969Z"
        fill={getBgIconSite()}
      />
      <path
        d="M37.0562 87.9938C37.0562 85.2323 39.2947 82.9938 42.0562 82.9938H56.5562C59.3176 82.9938 61.5562 85.2323 61.5562 87.9938V91.775C61.5562 94.5364 59.3176 96.775 56.5562 96.775H42.0562C39.2947 96.775 37.0562 94.5364 37.0562 91.775V87.9938Z"
        fill={getBgIconSite()}
      />
    </IconStyle>
  );
};

export const IconFile = ({ height, width, className, bgColor, disabled }: any) => {
  return (
    <IconStyle
      className={className}
      height={height}
      width={width}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 59C46.0163 59 59 46.0163 59 30C59 13.9837 46.0163 1 30 1C13.9837 1 1 13.9837 1 30C1 46.0163 13.9837 59 30 59Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M25.621 20.5999V18.8999C25.6216 18.7064 25.5842 18.5146 25.5107 18.3356C25.4372 18.1565 25.3292 17.9938 25.1927 17.8565C25.0563 17.7192 24.8942 17.6102 24.7156 17.5356C24.5371 17.4611 24.3455 17.4224 24.152 17.4219H13.973C13.7795 17.4217 13.588 17.4598 13.4092 17.5338C13.2304 17.6077 13.068 17.7162 12.9312 17.853C12.7943 17.9898 12.6859 18.1523 12.6119 18.3311C12.5379 18.5098 12.4999 18.7014 12.5 18.8949V41.1049C12.4999 41.2983 12.5379 41.4899 12.6119 41.6687C12.6859 41.8475 12.7943 42.0099 12.9312 42.1467C13.068 42.2835 13.2304 42.392 13.4092 42.466C13.588 42.54 13.7795 42.578 13.973 42.5779H46.027C46.2205 42.578 46.412 42.54 46.5908 42.466C46.7696 42.392 46.932 42.2835 47.0688 42.1467C47.2057 42.0099 47.3141 41.8475 47.3881 41.6687C47.4621 41.4899 47.5001 41.2983 47.5 41.1049V24.3639C47.5001 24.1704 47.4621 23.9788 47.3881 23.8C47.3141 23.6213 47.2057 23.4588 47.0688 23.322C46.932 23.1852 46.7696 23.0767 46.5908 23.0027C46.412 22.9288 46.2205 22.8907 46.027 22.8909H27.916C27.6148 22.8918 27.3164 22.833 27.038 22.7179C26.7593 22.6016 26.5062 22.4318 26.293 22.2179C26.08 22.0051 25.911 21.7524 25.7957 21.4742C25.6804 21.1961 25.621 20.898 25.621 20.5969V20.5999Z"
        fill="white"
      />
      <path
        d="M22.4479 39.9215H16.226C16.0785 39.9215 15.937 39.863 15.8328 39.7587C15.7285 39.6544 15.6699 39.513 15.6699 39.3655V33.7906C15.6695 33.6934 15.6947 33.5979 15.743 33.5136C15.7913 33.4293 15.8609 33.3592 15.945 33.3105C16.0289 33.2615 16.1241 33.2353 16.2213 33.2344C16.3184 33.2335 16.4142 33.258 16.499 33.3055L22.721 38.8805C22.8283 38.9407 22.9127 39.0349 22.9608 39.1482C23.009 39.2615 23.0181 39.3875 22.9869 39.5066C22.9557 39.6256 22.8858 39.731 22.7883 39.8061C22.6907 39.8811 22.571 39.9218 22.4479 39.9215V39.9215Z"
        fill={disabled ? 'white' : bgColor ? bgColor : getBgIconSite()}
      />
    </IconStyle>
  );
};

export const PreviewIcon = ({ onClick }: any) => {
  return (
    <IconStyle
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <circle cx="30" cy="30" r="30" fill={getColorSite()} />
      <rect x="31.8301" y="27" width="22" height="5" rx="1" transform="rotate(50 31.8301 27)" fill="white" />
      <circle cx="27.5" cy="25.5" r="12.5" fill="white" />
      <circle cx="27.5" cy="25.5" r="9.5" fill={getColorSite()} />
    </IconStyle>
  );
};

export const DownloadIcon = ({ onClick }: any) => {
  return (
    <IconStyle
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="30" fill={getColorSite()} />
        <rect x="10" y="21" width="4" height="26" rx="1" fill="white" />
        <rect x="10" y="47" width="4" height="40" rx="1" transform="rotate(-90 10 47)" fill="white" />
        <rect x="46" y="21" width="4" height="26" rx="1" fill="white" />
        <rect x="19" y="23.7754" width="4" height="18" rx="2" transform="rotate(-35 19 23.7754)" fill="white" />
        <rect
          width="4"
          height="18"
          rx="2"
          transform="matrix(-0.819152 -0.573576 -0.573576 0.819152 40.5 23.7754)"
          fill="white"
        />
        <rect width="4" height="22" rx="2" transform="matrix(1 0 0 -1 27.7998 33)" fill="white" />
      </svg>
    </IconStyle>
  );
};

export const IconUploadFile = () => {
  return (
    <IconStyle width="321" height="320" viewBox="0 0 321 320" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M318.5 160C318.5 246.977 247.768 317.5 160.5 317.5C73.2317 317.5 2.5 246.977 2.5 160C2.5 73.0225 73.2317 2.5 160.5 2.5C247.768 2.5 318.5 73.0225 318.5 160Z"
        fill="white"
        stroke={getColorSite()}
        strokeWidth="5"
      />
      <path
        d="M156.672 61.557C158.67 59.1786 162.33 59.1786 164.328 61.557L258.82 174.034C261.552 177.287 259.24 182.25 254.991 182.25H66.0086C61.7601 182.25 59.4475 177.287 62.1803 174.034L156.672 61.557Z"
        fill={getColorSite()}
      />
      <path
        d="M121 173H201V219C201 221.761 198.761 224 196 224H126C123.239 224 121 221.761 121 219V173Z"
        fill={getColorSite()}
      />
      <path
        d="M121 244C121 241.239 123.239 239 126 239H196C198.761 239 201 241.239 201 244V251C201 253.761 198.761 256 196 256H126C123.239 256 121 253.761 121 251V244Z"
        fill={getColorSite()}
      />
      <path
        d="M121 276C121 273.239 123.239 271 126 271H196C198.761 271 201 273.239 201 276V311C201 313.761 198.761 316 196 316H126C123.239 316 121 313.761 121 311V276Z"
        fill={getColorSite()}
      />
    </IconStyle>
  );
};

export const IconStaffMany = () => {
  return (
    <IconStyle width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30 59C46.0163 59 59 46.0163 59 30C59 13.9837 46.0163 1 30 1C13.9837 1 1 13.9837 1 30C1 46.0163 13.9837 59 30 59Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M20.9757 35.3321C26.2985 35.3321 30.6135 33.1746 30.6135 30.5132C30.6135 27.8518 26.2985 25.6943 20.9757 25.6943C15.6529 25.6943 11.3379 27.8518 11.3379 30.5132C11.3379 33.1746 15.6529 35.3321 20.9757 35.3321Z"
        fill="white"
      />
      <path
        d="M20.9772 34.9801C26.1099 34.9801 30.2707 32.9767 30.2707 30.5054C30.2707 28.0341 26.1099 26.0308 20.9772 26.0308C15.8445 26.0308 11.6836 28.0341 11.6836 30.5054C11.6836 32.9767 15.8445 34.9801 20.9772 34.9801Z"
        fill="white"
        stroke={getColorSite()}
      />
      <path
        d="M20.9759 28.4489C24.7779 28.4489 27.8601 25.3668 27.8601 21.5648C27.8601 17.7628 24.7779 14.6807 20.9759 14.6807C17.1739 14.6807 14.0918 17.7628 14.0918 21.5648C14.0918 25.3668 17.1739 28.4489 20.9759 28.4489Z"
        fill="white"
      />
      <path
        d="M20.9774 28.0969C24.5893 28.0969 27.5173 25.1689 27.5173 21.557C27.5173 17.9451 24.5893 15.0171 20.9774 15.0171C17.3655 15.0171 14.4375 17.9451 14.4375 21.557C14.4375 25.1689 17.3655 28.0969 20.9774 28.0969Z"
        fill="white"
        stroke={getColorSite()}
      />
      <path
        d="M39.6378 35.3321C44.9606 35.3321 49.2756 33.1746 49.2756 30.5132C49.2756 27.8518 44.9606 25.6943 39.6378 25.6943C34.315 25.6943 30 27.8518 30 30.5132C30 33.1746 34.315 35.3321 39.6378 35.3321Z"
        fill="white"
      />
      <path
        d="M39.6393 34.9801C44.772 34.9801 48.9328 32.9767 48.9328 30.5054C48.9328 28.0341 44.772 26.0308 39.6393 26.0308C34.5066 26.0308 30.3457 28.0341 30.3457 30.5054C30.3457 32.9767 34.5066 34.9801 39.6393 34.9801Z"
        fill="white"
        stroke={getColorSite()}
      />
      <path
        d="M39.638 28.4489C43.44 28.4489 46.5222 25.3668 46.5222 21.5648C46.5222 17.7628 43.44 14.6807 39.638 14.6807C35.836 14.6807 32.7539 17.7628 32.7539 21.5648C32.7539 25.3668 35.836 28.4489 39.638 28.4489Z"
        fill="white"
      />
      <path
        d="M39.6395 28.0969C43.2514 28.0969 46.1794 25.1689 46.1794 21.557C46.1794 17.9451 43.2514 15.0171 39.6395 15.0171C36.0276 15.0171 33.0996 17.9451 33.0996 21.557C33.0996 25.1689 36.0276 28.0969 39.6395 28.0969Z"
        fill="white"
        stroke={getColorSite()}
      />
      <path
        d="M30.3057 44.6356C35.6285 44.6356 39.9435 42.4781 39.9435 39.8167C39.9435 37.1553 35.6285 34.9978 30.3057 34.9978C24.9829 34.9978 20.668 37.1553 20.668 39.8167C20.668 42.4781 24.9829 44.6356 30.3057 44.6356Z"
        fill="white"
      />
      <path
        d="M30.3072 44.2836C35.4399 44.2836 39.6008 42.2802 39.6008 39.8089C39.6008 37.3376 35.4399 35.3342 30.3072 35.3342C25.1745 35.3342 21.0137 37.3376 21.0137 39.8089C21.0137 42.2802 25.1745 44.2836 30.3072 44.2836Z"
        fill="white"
        stroke={getColorSite()}
      />
      <path
        d="M30.306 37.7524C34.108 37.7524 37.1901 34.6703 37.1901 30.8683C37.1901 27.0663 34.108 23.9841 30.306 23.9841C26.504 23.9841 23.4219 27.0663 23.4219 30.8683C23.4219 34.6703 26.504 37.7524 30.306 37.7524Z"
        fill="white"
      />
      <path
        d="M30.3075 37.4004C33.9194 37.4004 36.8474 34.4724 36.8474 30.8605C36.8474 27.2486 33.9194 24.3206 30.3075 24.3206C26.6956 24.3206 23.7676 27.2486 23.7676 30.8605C23.7676 34.4724 26.6956 37.4004 30.3075 37.4004Z"
        fill="white"
        stroke={getColorSite()}
      />
      <path
        d="M37.6429 42.55H33.25V39.5833H37.6429H37.8929V39.3333V35.25H41.1071V39.3333V39.5833H41.3571H45.75V42.55H41.3571H41.1071V42.8V47.75H37.8929V42.8V42.55H37.6429Z"
        fill="white"
        stroke={getColorSite()}
        strokeWidth="0.5"
      />
    </IconStyle>
  );
};

export const IconCalendar = ({ date = 1 }: { date?: number }) => {
  return (
    <IconCalendarWrapper>
      <span className="number">{date < 10 ? '0' + date : date}</span>
      <svg width="29" height="23" viewBox="0 0 29 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.3103 4.41379H1V22.3362H28.3103V4.41379Z" fill="white" />
        <path d="M27.6708 5.05386H1.64062V21.6961H27.6708V5.05386Z" stroke={getColorSite()} stroke-width="1.5" />
        <path d="M28.3103 1H1V3.56034H28.3103V1Z" fill={getColorSite()} />
        <path d="M27.457 1.85345H1.85352V2.7069H27.457V1.85345Z" stroke={getColorSite()} stroke-width="2" />
        <path d="M10.3885 1H7.82812V2.7069H10.3885V1Z" fill="white" />
        <path d="M21.4822 1H18.9219V2.7069H21.4822V1Z" fill="white" />
        <path d="M9.74697 1H8.4668V2.28017H9.74697V1Z" fill={getColorSite()} />
        <path d="M20.8427 1H19.5625V2.28017H20.8427V1Z" fill={getColorSite()} />
      </svg>
    </IconCalendarWrapper>
  );
};

export const ModalUploadBanner = ({ height, width }: any) => {
  return (
    <IconStyle
      height={height || '321'}
      width={width || '320'}
      viewBox="0 0 321 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M318.5 160C318.5 246.977 247.768 317.5 160.5 317.5C73.2317 317.5 2.5 246.977 2.5 160C2.5 73.0225 73.2317 2.5 160.5 2.5C247.768 2.5 318.5 73.0225 318.5 160Z"
        fill="white"
        stroke={getColorSite()}
        stroke-width="5"
      />
      <path
        d="M156.672 61.557C158.67 59.1786 162.33 59.1786 164.328 61.557L258.82 174.034C261.552 177.287 259.24 182.25 254.991 182.25H66.0086C61.7601 182.25 59.4475 177.287 62.1803 174.034L156.672 61.557Z"
        fill={getColorSite()}
      />
      <path
        d="M121 173H201V219C201 221.761 198.761 224 196 224H126C123.239 224 121 221.761 121 219V173Z"
        fill={getColorSite()}
      />
      <path
        d="M121 244C121 241.239 123.239 239 126 239H196C198.761 239 201 241.239 201 244V251C201 253.761 198.761 256 196 256H126C123.239 256 121 253.761 121 251V244Z"
        fill={getColorSite()}
      />
      <path
        d="M121 276C121 273.239 123.239 271 126 271H196C198.761 271 201 273.239 201 276V311C201 313.761 198.761 316 196 316H126C123.239 316 121 313.761 121 311V276Z"
        fill={getColorSite()}
      />
    </IconStyle>
  );
};
export const IconNotice = () => {
  return (
    <IconStyle viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22" cy="22" r="22" fill={getColorSite()} />
      <circle cx="21.9996" cy="9.68418" r="4.4" fill="white" />
      <rect x="17.5996" y="17.5977" width="7.92" height="21.12" rx="3.96" fill="white" />
    </IconStyle>
  );
};

export const IconChecked = ({ height, width }: any) => {
  return (
    <IconStyle height={height} width={width} viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31 61C47.5685 61 61 47.5685 61 31C61 14.4315 47.5685 1 31 1C14.4315 1 1 14.4315 1 31C1 47.5685 14.4315 61 31 61Z"
        stroke={getColorSite()}
        stroke-width="2"
      />
      <rect
        x="13.4141"
        y="30.522"
        width="5.17241"
        height="19.6552"
        rx="2.5"
        transform="rotate(-45 13.4141 30.522)"
        fill={getColorSite()}
      />
      <rect
        width="6.23338"
        height="30.3204"
        rx="3.0128"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 48.5723 22.9985)"
        fill={getColorSite()}
      />
    </IconStyle>
  );
};
export const IconHistoryFootsteps = ({ height, width }: any) => {
  return (
    <IconStyle height={height} width={width} viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.5 63C48.897 63 63 48.897 63 31.5C63 14.103 48.897 0 31.5 0C14.103 0 0 14.103 0 31.5C0 48.897 14.103 63 31.5 63Z"
          fill="white"
        />
        <path
          d="M31.5 62.5C48.6208 62.5 62.5 48.6208 62.5 31.5C62.5 14.3792 48.6208 0.5 31.5 0.5C14.3792 0.5 0.5 14.3792 0.5 31.5C0.5 48.6208 14.3792 62.5 31.5 62.5Z"
          stroke={getColorSite()}
        />
        <path
          d="M32.5 55C44.3741 55 54 49.8513 54 43.5C54 37.1487 44.3741 32 32.5 32C20.6259 32 11 37.1487 11 43.5C11 49.8513 20.6259 55 32.5 55Z"
          fill={getColorSite()}
        />
        <path
          d="M32.5 54.5C44.098 54.5 53.5 49.5751 53.5 43.5C53.5 37.4249 44.098 32.5 32.5 32.5C20.902 32.5 11.5 37.4249 11.5 43.5C11.5 49.5751 20.902 54.5 32.5 54.5Z"
          stroke="white"
        />
        <path
          d="M32.5 38C41.0604 38 48 30.8366 48 22C48 13.1634 41.0604 6 32.5 6C23.9396 6 17 13.1634 17 22C17 30.8366 23.9396 38 32.5 38Z"
          fill={getColorSite()}
        />
        <path
          d="M32.5 37.5C40.7843 37.5 47.5 30.5604 47.5 22C47.5 13.4396 40.7843 6.5 32.5 6.5C24.2157 6.5 17.5 13.4396 17.5 22C17.5 30.5604 24.2157 37.5 32.5 37.5Z"
          stroke="white"
        />
      </svg>
    </IconStyle>
  );
};
